import React, { useState } from 'react';
import "./ValidationForm.css";

const ValidatedOcrInput = ({ 
    label, 
    endpointId, 
    validatorFunction
}) => {
    // Estados para las imágenes
    const [frontImage, setFrontImage] = useState(null);
    const [backImage, setBackImage] = useState(null);
    
    // Estados de UI
    const [status, setStatus] = useState("idle"); // idle, loading, success, error
    const [errorMsg, setErrorMsg] = useState("");
    const [dataSummary, setDataSummary] = useState(null);
    const [showDetails, setShowDetails] = useState(false);

    // Helper: Convertir archivo a Base64 puro (sin el header data:image...)
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // Quitamos "data:image/png;base64," para enviar solo el string
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = error => reject(error);
        });
    };

    const handleValidate = async () => {
        if (!frontImage) {
            setErrorMsg("Debe cargar al menos el frente del documento.");
            setStatus("error");
            return;
        }

        setStatus("loading");
        setErrorMsg("");
        setDataSummary(null);
        setShowDetails(false);

        try {
            // 1. Convertir imágenes
            const base64Front = await convertToBase64(frontImage);
            let params = [{ "name": "id", "value": base64Front }];

            if (backImage) {
                const base64Back = await convertToBase64(backImage);
                params.push({ "name": "idReverso", "value": base64Back });
            }

            // 2. Llamar API
            const response = await fetch('/api-proxy', {
                method: 'POST',
                headers: {
                    'PublicApiKey': '8c9348d8-bac6-493d-95e4-26f68cfbe822',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idEndPoint: endpointId,
                    params: params
                })
            });

            const rawData = await response.json();
            console.log(`Respuesta OCR (${label}):`, rawData);

            // 3. Validar con lógica de negocio
            const result = validatorFunction(rawData);

            if (result.isValid) {
                setStatus("success");
                setDataSummary(result.summary);
            } else {
                setStatus("error");
                setErrorMsg(result.message || "Documento ilegible o inválido");
            }

        } catch (error) {
            console.error(error);
            setStatus("error");
            setErrorMsg("Error al procesar las imágenes.");
        }
    };

    return (
        <div className="form_step_group">
            <label className="step_label">{label}</label>
            
            <div className="ocr_upload_container">
                
                {/* --- Input Frente --- */}
                <div className="file_input_wrapper">
                    <span className="file_label">Frente (Obligatorio)</span>
                    <input 
                        type="file" 
                        accept="image/*"
                        onChange={(e) => {
                            setFrontImage(e.target.files[0]);
                            if(status === 'error') setStatus('idle');
                        }}
                        disabled={status === 'loading'}
                    />
                    {/* Mostramos el nombre nosotros mismos */}
                    <div className="selected_filename">
                        {frontImage ? frontImage.name : ""}
                    </div>
                </div>

                {/* --- Input Reverso --- */}
                <div className="file_input_wrapper">
                    <span className="file_label">Reverso (Opcional)</span>
                    <input 
                        type="file" 
                        accept="image/*"
                        onChange={(e) => setBackImage(e.target.files[0])}
                        disabled={status === 'loading'}
                    />
                    {/* Mostramos el nombre nosotros mismos */}
                    <div className="selected_filename">
                        {backImage ? backImage.name : ""}
                    </div>
                </div>
            </div>

            {/* ... El resto de tus botones y alertas sigue igual ... */}
            <div className="input_button_wrapper" style={{marginTop: '15px'}}>
                <button 
                    className="btn_validate"
                    onClick={handleValidate}
                    disabled={status === 'loading' || !frontImage}
                >
                    {status === 'loading' ? 'Procesando OCR...' : 'Analizar Documento'}
                </button>
                
                {/* ... resto del código ... */}
                {status === 'success' && (
                    <button 
                        className="btn_ghost"
                        onClick={() => setShowDetails(!showDetails)}
                    >
                        {showDetails ? 'Ocultar Datos' : 'Ver Datos Extraídos'}
                    </button>
                )}
                 <div className="step_status_icon_static">
                    {status === 'loading' && <div className="spinner"></div>}
                    {status === 'success' && <div className="check_mark">✔</div>}
                    {status === 'error' && <div className="error_mark">✖</div>}
                </div>
            </div>

            {status === 'error' && <p className="error_text">{errorMsg}</p>}
            {status === 'success' && !showDetails && <p className="success_text_small">Documento vigente y válido.</p>}

            {/* FICHA TÉCNICA (CARD DE DETALLES) */}
            {status === 'success' && showDetails && dataSummary && (
                <div className="data_details_card animate_fade_in">
                    <div className="details_header">
                        Datos del INE/IFE (OCR)
                    </div>
                    <div className="details_grid">
                        {Object.entries(dataSummary).map(([key, val]) => (
                            <div key={key} className="detail_item">
                                <span className="detail_label">{key}:</span>
                                <span className="detail_value">{val || "No detectado"}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ValidatedOcrInput;